<template>
    <Button class="bg-red" @click="$emit('click')">
        <span class="white center">
            <slot></slot>
        </span>
    </Button>
</template>

<script>
import Button from '@/components/buttons/Button.vue';

export default {
    components: {
        Button
    }
};
</script>
